import React, { useEffect } from 'react'
import SEO from '../../../utils/CommonFunctionality/SEO'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
import Layout from '../Layout'
import Header from '../Header'

export default function wareHouse(props) {
    const isPrimeBids = global.storeConfigration?.bodyClass?.value == 'primeBids'

    useEffect(() => {
        if (
            global?.storeDetails?.site_id == 'AS0698' ||
            global?.storeDetails?.site_id == 'AS0575'
        ) {
            const hsformScript = document.createElement('script')
            // hsformScript.async = true
            hsformScript.src = `https://js-na2.hsforms.net/forms/embed/242443259.js`
            document.body.appendChild(hsformScript)
        }

        return () => {
            document.body.removeChild(hsformScript)
        }
    }, [])

    return (
        <>
            {isPrimeBids ? <SEOTAG page="Warehouse" /> : null}
            <div className="app-wrapper">
                <Header />
                <div className="main-container">
                    <div className="px-md-5 px-3 py-4 staticPgWrapper">
                        {/* <h2>FAQs</h2> */}
                        <span
                            dangerouslySetInnerHTML={{
                                __html: global.storeDetails.seller_info,
                            }}
                        ></span>
                    </div>
                </div>
            </div>
        </>
    )
}
